// extracted by mini-css-extract-plugin
export var cardContainer = "Card-module--cardContainer--b0361";
export var cardIconContainer = "Card-module--cardIconContainer--407ff";
export var label = "Card-module--label--6b12e";
export var parent = "Card-module--parent--3ce30";